import {BDropdown} from 'bootstrap-vue/src/components/dropdown/dropdown.js';

export default {
  name: 'bDropdownTest',
  mixins: [BDropdown],
  methods: {
    rootCloseListener(vm) {
      // prevent close when dropdown item is clicked
      if (vm instanceof MouseEvent) {
        return;
      }
      // close when other dropdown on page is opened
      bDropdown.mixins[1].methods.rootCloseListener.call(this, vm);
    }
  }
};
